import { useLocation } from 'react-router-dom';
import ChangePassword from '../components/auth/change-password-form';
import { ResetPasswordForm } from '../components/auth/reset-password-form';
import { Seo } from '../components/seo';
import { useAuthStore } from '../store/auth-store';
import { Alert } from 'antd';
import { useNavigate } from 'react-router-dom';
import { InitiateResetPasswordForm } from '../components/auth/initiate-reset-password-form';

function ResetPasswordPage() {
  const location = useLocation();
  const { email } = location.state || {};
  const forgotPasswordEmail = email;
  const navigate = useNavigate();

  // const resetSuccess = useAuthStore(state => state.resetSuccess);
  const resetSuccess = 'Your password was updated successfully';

  return (
    <>
      <Seo title="Reset Password" />
      <div className="max-w-[311px] tracking-[-0.32px]">
        <h2 className="font-inter font-bold text-[2rem] text-black leading-[-0.32px]">
          Reset Password
        </h2>
        <div className="mt-6 max-w-[416px]">
          {forgotPasswordEmail ? (
            // <ChangePassword value={forgotPasswordEmail} />
            <InitiateResetPasswordForm emailUsedToReceiveCode={forgotPasswordEmail}/>
          ) : resetSuccess ? (
            <>
              <Alert type="success" message={resetSuccess} className="mb-2" />
              <fieldset className="flex flex-row mt-6">
                <button
                  type="submit"
                  onClick={() => {
                    navigate('/auth/login');
                  }}
                  className="bg-red-900 text-white flex-1 hover:bg-[#aaaaaa] shadow-lg p-2 text-lg rounded-lg transition duration-150">
                  Continue
                </button>
              </fieldset>
            </>
          ) : (
            <>
              Password reset request expired.
              <br />
              <a href="/auth/forgot-password" className="text-red-900 ">
                Click here to try again
              </a>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default ResetPasswordPage;
